import styled, { css } from "styled-components";
import React, { Component, Fragment } from "react";
import { SearchBar } from "js/react/views/AddSlide/Panes/Components/SearchBox";
import { Icon, IconButton, MenuItem } from "@material-ui/core";
import { IconMenu } from "js/react/components/UiComponents";
import { app } from "js/namespaces";
import { themeColors } from "js/react/sharedStyles";

const StyledLibraryHeader = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 12px;
`;

const StyledSearchBar = styled(SearchBar)`
    width: 100%;
    padding: 6px 10px;
    margin: 0;
    gap: 10px;
    min-height: 40px;
    border: 1px solid #d7dce3;
    border-radius: 100px;
    background: white;
    box-sizing: border-box;

    .MuiIcon-root {
        color: ${themeColors.ui_blue};
    }

    .clear-search {
        right: 12px;
        margin-right: 0;
    }

    input[type="text"] {
        width: 100%;
        margin: 0;
        font-size: 16px;
        font-weight: 500;
        padding-right: 24px;
    }

    input[type="text"]::placeholder {
        color: #999;
        font-family: "Source Sans Pro";
        font-size: 16px;
        font-weight: 400;
        line-height: 150%;    
    }
`;

const HeaderTopRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    min-height: 50px;
    width: 100%;
    min-width: 0;
`;

const HeaderLeft = styled.div`
    display: flex;
    align-items: center;
    min-width: 0;
    flex: 1;
`;

const HeaderLeadingContent = styled.div`
    min-width: 0;
`;

const HeaderControls = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
`;

const HeaderRight = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
`;

const iconMenuStyles = css`
    &&& {
        padding: 0;

        .bai-icon,
        .material-icons,
        .MuiIcon-root,
        .MuiSvgIcon-root {
            color: ${themeColors.darkGray};
        }
    }
`;

const StyledIconMenu = styled(IconMenu)`
    ${iconMenuStyles};
`;

const StyledIconButton = styled(IconButton)`
    ${iconMenuStyles};
`;

export class PresentationListHeader extends Component {
    componentDidMount() {
        this.props.onSearchBarOpen && this.props.onSearchBarOpen();
    }

    handleSetSort = sort => {
        this.props.onSetSort && this.props.onSetSort(sort);
    }

    handleSearch = value => {
        this.props.onSearch && this.props.onSearch(value);
    }

    toggleViewType = () => {
        const viewType = this.props.viewType == "grid" ? "list" : "grid";
        this.props.onSetViewType && this.props.onSetViewType(viewType);
    }

    render() {
        const {
            sortOptions,
            viewType = "grid",
            className = "",
            leadingContent,
            headerAction,
            searchPlaceholder
        } = this.props;

        return (
            <StyledLibraryHeader className={className}>
                <HeaderTopRow>
                    <HeaderLeft>
                        {leadingContent && <HeaderLeadingContent>{leadingContent}</HeaderLeadingContent>}
                    </HeaderLeft>
                    <HeaderRight>
                        <HeaderControls>
                            <Fragment>
                                <StyledIconMenu icon="sort" $isMobile={app.isMobileOrTablet}>
                                    {sortOptions.map(option => (
                                        <MenuItem
                                            key={option.value}
                                            selected={this.props.sort.field === option.value}
                                            onClick={() => this.handleSetSort({
                                                field: option.value,
                                                reverse: option.reverse
                                            })}>
                                            {option.icon && <Icon>{option.icon}</Icon>}
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </StyledIconMenu>
                            </Fragment>
                            <StyledIconButton onClick={() => this.toggleViewType()} $isMobile={app.isMobileOrTablet}>
                                <Icon>{viewType == "grid" ? "view_module" : "view_list"}</Icon>
                            </StyledIconButton>
                        </HeaderControls>
                        {headerAction}
                    </HeaderRight>
                </HeaderTopRow>

                <StyledSearchBar
                    showIcon
                    placeholder={searchPlaceholder}
                    onSearch={this.handleSearch}
                    $isMobile={app.isMobileOrTablet}
                />
            </StyledLibraryHeader>
        );
    }
}
